import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AppRouter from "./Router/app.router";

function App() {
  return (
    <AppRouter/>
  );
}
export default App;
